module.exports = __webpack_public_path__ + "static/media/AboutImg.5eb7f86a.jpg";